module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/foilTagTransparent@2x-819838bfbfd047251ebe08776c06a7f3.png";